import { AxiosError } from 'axios';
import { useState } from 'react';

// import toast from 'react-hot-toast';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useHiringConflictCount = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [conflictCount, setConflictCount] = useState(0);

  const onHiringConflictCountError = (err: AxiosError<ErrorHttpResponse>) => {
    console.error(
      err?.response?.data?.message ??
      'Something went wrong while fetching hiring conflict count.',
    );
  };

  const onHiringConflictCountSuccess = ({
    data,
    message,
  }: SuccessHttpResponse<any>) => {
    // toast.success('Hiring conflict count fetched successfully.');
    setConflictCount(data ?? 0);
  };

  const hiringConflictCount = () => {
    const url: HttpConfig = {
      url: 'api/v1/company/hiring-conflicts/total-count',
      method: 'get',
    };
    request(url, onHiringConflictCountSuccess, setLoading, onHiringConflictCountError);
  };

  return { hiringConflictCount, loading, conflictCount };
};

export default useHiringConflictCount;
